/* Copyright (C) NewFoundry 2022 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var _defineProperty = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.style = exports.name = exports.Slideshow = void 0;

var react_1 = __importDefault(require("react"));

var icon_close_png_1 = __importDefault(require("./assets/icon-close.png"));

var utils_1 = require("./utils");

var name = 'Slideshow';
exports.name = name;

var Slideshow = function Slideshow(_ref) {
  var Frame = _ref.Frame,
      Image = _ref.Image,
      styles = _ref.styles;
  return /*#__PURE__*/function (_react_1$default$Pure) {
    _inherits(_class, _react_1$default$Pure);

    var _super = _createSuper(_class);

    function _class(props) {
      var _this;

      _classCallCheck(this, _class);

      _this = _super.call(this, props);
      _this.state = {
        index: 0
      };
      _this.handleSelect = _this.handleSelect.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(_class, [{
      key: "handleSelect",
      value: function handleSelect(slide, index) {
        if (slide === null || slide === void 0 ? void 0 : slide.onSelect) {
          slide.onSelect(index);
        }

        this.setState({
          index: index
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props = this.props,
            after = _this$props.after,
            before = _this$props.before,
            classes = _this$props.classes,
            _this$props$slides = _this$props.slides,
            slides = _this$props$slides === void 0 ? [] : _this$props$slides;
        var index = this.state.index;

        var backToStart = function backToStart() {
          return _this2.handleSelect(slides[0], 0);
        };

        return react_1.default.createElement(Frame, {
          className: ['Slideshow__container', classes === null || classes === void 0 ? void 0 : classes.container],
          style: styles === null || styles === void 0 ? void 0 : styles.container
        }, before, react_1.default.createElement(Frame, {
          className: ['Slideshow__inner', classes === null || classes === void 0 ? void 0 : classes.inner],
          style: styles === null || styles === void 0 ? void 0 : styles.inner
        }, react_1.default.createElement(Frame, {
          className: ['Slideshow__slides', classes === null || classes === void 0 ? void 0 : classes.slides],
          style: styles === null || styles === void 0 ? void 0 : styles.slides
        }, slides.map(function (slide, i) {
          var slideClass = index === i ? classes === null || classes === void 0 ? void 0 : classes.active : classes === null || classes === void 0 ? void 0 : classes.inactive;
          var slideStyle = index === i ? styles === null || styles === void 0 ? void 0 : styles.active : styles === null || styles === void 0 ? void 0 : styles.inactive;
          return react_1.default.createElement(Frame, {
            className: ['Slideshow__slide', classes === null || classes === void 0 ? void 0 : classes.slide, slideClass],
            style: Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.slide), slideStyle)
          }, (slide === null || slide === void 0 ? void 0 : slide.close) && react_1.default.createElement(Image, {
            className: ['Slideshow__close', classes === null || classes === void 0 ? void 0 : classes.close],
            onClick: backToStart,
            src: icon_close_png_1.default,
            style: styles === null || styles === void 0 ? void 0 : styles.close
          }), react_1.default.createElement(Frame, {
            className: ['Slideshow__slide-inner', classes === null || classes === void 0 ? void 0 : classes.slideInner],
            style: Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.slideInner), {
              backgroundImage: "url(".concat(slide.image, ")")
            })
          }, slide.content));
        })), react_1.default.createElement(Frame, {
          className: ['Slideshow__thumbs', classes === null || classes === void 0 ? void 0 : classes.thumbs],
          style: styles === null || styles === void 0 ? void 0 : styles.thumbs
        }, slides.map(function (slide, i) {
          return react_1.default.createElement(Frame, {
            className: ['Slideshow__thumb', _defineProperty({}, (classes === null || classes === void 0 ? void 0 : classes.selected) || '', i === index), classes === null || classes === void 0 ? void 0 : classes.thumb],
            style: styles === null || styles === void 0 ? void 0 : styles.thumb,
            onClick: function onClick() {
              return _this2.handleSelect(slide, i);
            }
          }, react_1.default.createElement(Frame, {
            className: ['Slideshow__thumb-inner', classes === null || classes === void 0 ? void 0 : classes.thumbInner],
            style: Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.thumbInner), {
              backgroundImage: "url(".concat(slide.thumbnail, ")")
            })
          }));
        }))), after);
      }
    }]);

    return _class;
  }(react_1.default.PureComponent);
};

exports.Slideshow = Slideshow;

var style = function style(theme) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;

  return {
    active: {
      zIndex: 1
    },
    close: Object.assign(Object.assign({
      color: (_a = theme.colors) === null || _a === void 0 ? void 0 : _a.secondary,
      cursor: 'pointer',
      height: 40,
      position: 'absolute',
      right: 15,
      top: 15,
      width: 40
    }, (_b = theme === null || theme === void 0 ? void 0 : theme.Slideshow) === null || _b === void 0 ? void 0 : _b.close), _defineProperty({}, "@media (max-width: ".concat((_c = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _c === void 0 ? void 0 : _c.mobile, "px)"), {
      height: 24,
      width: 24
    })),
    container: Object.assign(_defineProperty({
      display: 'flex',
      flexDirection: 'row',
      maxWidth: '100%',
      overflow: 'hidden'
    }, "@media (max-width: ".concat((_d = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _d === void 0 ? void 0 : _d.mobile, "px)"), {
      overflow: 'visible'
    }), (_e = theme === null || theme === void 0 ? void 0 : theme.Slideshow) === null || _e === void 0 ? void 0 : _e.container),
    inactive: {
      zIndex: -1
    },
    inner: Object.assign(_defineProperty({
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      height: '100%',
      maxWidth: '100%'
    }, "@media (max-width: ".concat((_f = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _f === void 0 ? void 0 : _f.mobile, "px)"), {
      overflow: 'visible'
    }), (_g = theme === null || theme === void 0 ? void 0 : theme.Slideshow) === null || _g === void 0 ? void 0 : _g.inner),
    selected: Object.assign({
      borderBottomColor: '#ACACAC !important'
    }, (_h = theme === null || theme === void 0 ? void 0 : theme.Slideshow) === null || _h === void 0 ? void 0 : _h.selected),
    slide: Object.assign({
      bottom: 0,
      display: 'flex',
      left: 0,
      position: 'absolute',
      right: 0,
      top: 0
    }, theme === null || theme === void 0 ? void 0 : theme.Slideshow.slide),
    slides: Object.assign({
      display: 'flex',
      flex: 1,
      position: 'relative'
    }, theme === null || theme === void 0 ? void 0 : theme.Slideshow.slides),
    slideInner: Object.assign({
      alignItems: 'center',
      background: '#ffffff',
      backgroundPosition: '50%',
      backgroundSize: 'cover',
      display: 'flex',
      flex: 1,
      justifyContent: 'center',
      textAlign: 'center'
    }, theme === null || theme === void 0 ? void 0 : theme.Slideshow.slideInner),
    slideshow: Object.assign({
      background: '#A3A2A2',
      color: '#fff',
      cursor: 'pointer',
      flex: 1,
      padding: 10,
      textAlign: 'center'
    }, (_j = theme === null || theme === void 0 ? void 0 : theme.Slideshow) === null || _j === void 0 ? void 0 : _j.Slideshow),
    slideshowActive: Object.assign({
      background: '#000'
    }, (_k = theme === null || theme === void 0 ? void 0 : theme.Slideshow) === null || _k === void 0 ? void 0 : _k.SlideshowActive),
    slideshowFirst: Object.assign(Object.assign({}, utils_1.StyleUtils.borderRadius('5px 0px 0px 5px')), (_l = theme === null || theme === void 0 ? void 0 : theme.Slideshow) === null || _l === void 0 ? void 0 : _l.SlideshowFirst),
    slideshowLast: Object.assign(Object.assign({}, utils_1.StyleUtils.borderRadius('0px 5px 5px 0px')), (_m = theme === null || theme === void 0 ? void 0 : theme.Slideshow) === null || _m === void 0 ? void 0 : _m.SlideshowLast),
    thumb: Object.assign(Object.assign(Object.assign(Object.assign({}, utils_1.StyleUtils.borderBottom('5px solid #FFF')), {
      cursor: 'pointer',
      display: 'flex',
      margin: 5
    }), utils_1.StyleUtils.padding('5px 0px')), (_o = theme === null || theme === void 0 ? void 0 : theme.Slideshow) === null || _o === void 0 ? void 0 : _o.thumb),
    thumbInner: Object.assign({
      backgroundPosition: '50%',
      backgroundSize: 'cover',
      display: 'flex',
      flex: 1,
      justifyContent: 'center',
      maxWidth: '100%'
    }, (_p = theme === null || theme === void 0 ? void 0 : theme.Slideshow) === null || _p === void 0 ? void 0 : _p.thumbInner),
    thumbs: Object.assign({
      display: 'flex',
      flexDirection: 'row',
      height: 100,
      maxWidth: '100%',
      overflow: 'scroll'
    }, (_q = theme === null || theme === void 0 ? void 0 : theme.Slideshow) === null || _q === void 0 ? void 0 : _q.thumbs)
  };
};

exports.style = style;